import { SelectOption } from '../../../components/CiscoUi';

export const TEMPLATE_VISIBILITY_OPTIONS: SelectOption<TemplateVisibilityValues>[] =
  [
    { name: 'GSE Only', value: 'DEVELOPER' },
    { name: 'All Users', value: 'ALL_USERS' },
    { name: 'Archived', value: 'ARCHIVED' },
  ];

export const [{ value: DEFAULT_TEMPLATE_VISIBILITY_VALUE }] =
  TEMPLATE_VISIBILITY_OPTIONS;

export const LABEL_KEYS = {
  ALL_USERS: 'allUsers',
  ARCHIVED: 'archived',
  DEVELOPER: 'developer',
};

export const TRANSLATION_KEY_PREFIX = 'templateManager.common.visibility.';
